import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { DY_PAGE_CONTEXT } from "@Constants/common";
import { getPageTypeForDY } from "@Utils/dynamicYield";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";

export const useCurrentPageContextByPath = () => {
  const [currentPageContext, setCurrentPageContext] = useState(
    DY_PAGE_CONTEXT.HOMEPAGE
  );
  const { languageCode } = useAppSelector(localeSelector);
  const router = useRouter();
  const currentPath = router.asPath;

  useEffect(() => {
    const currentLocalePosition = currentPath?.indexOf(`/${languageCode}`);
    // Extract the path after current locale
    const resourcePath = currentPath?.slice(
      currentLocalePosition + `/${languageCode}`?.length
    );
    setCurrentPageContext(getPageTypeForDY(resourcePath));
  }, [currentPath, languageCode]);

  return currentPageContext;
};
